import { Suspense } from 'react';

import { SocketProvider, TextChatProvider } from '@mint-lib/ai-chat';
import { ChatHistorySkeleton } from '@mint-lib/ai-chat/components';

import { Drawer } from '@myn/mui';

import { TOP_BAR_HEIGHT } from '../../../constants/common.js';
import { useAiSidebarContext } from '../../../context.jsx';
import AiContent from '../AiContent/AiContent.jsx';
import { SuggestionPreview } from '../SuggestionPreview/SuggestionPreview.jsx';

const Sidebar = () => {
  const { isAiSidebarOpen, sidebarWidth, currentChat, target } =
    useAiSidebarContext();

  return (
    <Drawer
      sx={{
        width: 0,

        '& .MuiDrawer-paper': {
          backgroundColor: (theme) => theme.palette.ui.primary,
          marginTop: `${TOP_BAR_HEIGHT}px`,
          height: `calc(100vh - ${TOP_BAR_HEIGHT}px)`,
          width: sidebarWidth,
          boxSizing: 'border-box',
          borderLeft: (theme) => `1px solid ${theme.palette.border.primary}`,
        },
      }}
      anchor="right"
      open={isAiSidebarOpen}
      variant="persistent"
    >
      {currentChat ? (
        <SocketProvider chatId={currentChat}>
          <TextChatProvider target={target}>
            <Suspense fallback={<ChatHistorySkeleton />}>
              <AiContent />
            </Suspense>
          </TextChatProvider>
        </SocketProvider>
      ) : (
        <SuggestionPreview />
      )}
    </Drawer>
  );
};
export default Sidebar;
